import { Link } from '@tanstack/react-router';
import { useState } from 'react';

import { Button } from '@/components/ui/button';
import { useCsReviewProposals } from '@/lib/api/cs-reviews';

import { ProposalCard } from './proposal-card';

export function ProposalsListPage() {
  const [pending, setPending] = useState(true);
  const proposalsQuery = useCsReviewProposals({ pending });

  return (
    <div className="space-y-6">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight">Draft review proposals</h1>
          <p className="text-sm text-[var(--color-muted-foreground)]">
            KB changes apply when CS confirms. Prompt rules apply when an admin approves: the rule
            is appended to a new drafter version and the Intercom binding moves to it.
          </p>
        </div>
        <Button variant="outline" onClick={() => setPending((value) => !value)}>
          {pending ? 'Show decided too' : 'Show pending only'}
        </Button>
      </div>

      {proposalsQuery.isPending && <p className="text-sm">Loading…</p>}
      {proposalsQuery.isError && (
        <p className="text-sm text-[var(--color-destructive)]">
          Failed to load proposals: {proposalsQuery.error.message}
        </p>
      )}
      {proposalsQuery.data?.length === 0 && (
        <p className="text-sm text-[var(--color-muted-foreground)]">Nothing waiting.</p>
      )}
      {proposalsQuery.data?.map((proposal) => (
        <div key={proposal.id} className="space-y-1">
          <Link
            to="/review/$sessionId"
            params={{ sessionId: proposal.sessionId }}
            className="text-xs text-[var(--color-muted-foreground)] hover:underline"
          >
            Conversation {proposal.intercomConversationId} ·{' '}
            {new Date(proposal.createdAt).toLocaleString()}
          </Link>
          <ProposalCard proposal={proposal} />
        </div>
      ))}
    </div>
  );
}
